// ============================================================================
// 3. Sticky Progress Footer

import { BaseButton } from '@/components/Buttons/base';

// ============================================================================
export default ({
  currentCount,
  maxCount,
  onAddToCart,
  basePrice = 15.0,
  isExisting = false,
}: {
  currentCount: number;
  maxCount: number;
  onAddToCart: (e: React.MouseEvent<HTMLButtonElement>) => void;
  basePrice: number;
  isExisting: boolean;
}) => {
  const isFull = currentCount === maxCount;
  const progressPercentage = maxCount > 0 ? (currentCount / maxCount) * 100 : 0;

  // Format price (Assuming basePrice is updated based on size selection in a real app)
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(basePrice);

  return (
    <div className="sticky bottom-0 left-0 w-full bg-white border-t border-brand-truffle/10 p-4 md:px-8 pb-safe shadow-lift">
      <div className="max-w-4xl mx-auto flex flex-col gap-4">
        {/* Top: Progress Bar & Status */}
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-end">
            <span className="font-display font-bold text-text-heading text-sm uppercase tracking-widest">
              Your Box
            </span>
            <span className="font-body text-sm font-semibold text-text-muted">
              <span
                className={isFull ? 'text-brand-success' : 'text-brand-truffle'}
              >
                {currentCount}
              </span>{' '}
              / {maxCount || '?'} Selected
            </span>
          </div>
          <div className="h-1.5 w-full bg-text-muted/50 rounded-full overflow-hidden">
            <div
              className={`h-full transition-all duration-500 ease-out ${isFull ? 'bg-brand-gold' : 'bg-brand-truffle'}`}
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>

        {/* Bottom: Price & Action */}
        <div className="flex items-center justify-between pt-1">
          <div className="flex flex-col">
            <span className="font-body text-xs text-text-muted uppercase tracking-widest">
              Total
            </span>
            <span className="font-display font-bold text-xl text-text-heading">
              {formattedPrice}
            </span>
          </div>
          <BaseButton
            onClick={onAddToCart}
            disabled={!isFull || maxCount === 0}
            variant="none"
            className={`bg-brand-truffle border-1 border-brand-truffle hover:border-brand-truffle-2 hover:bg-brand-cream focus:bg-brand-cream focus:text-brand-truffle hover:text-brand-truffle font-display text-brand-cream font-[500] disabled:font-[400] text-[0.9em] leading-[1.8em] w-fit px-4 !py-2 !rounded-full flex items-center justify-center lift-light transition-colors disabled:border-gray-300 duration-300 disabled:cursor-not-allowed whitespace-nowrap`}
          >
            {isFull
              ? isExisting
                ? 'Save'
                : 'Add to cart'
              : 'Fill Box to Continue'}
          </BaseButton>
        </div>
      </div>
    </div>
  );
};
